import { URLS } from '../../../constants';
import apiClient from '../../client';

const OrganizationsByIdApi = {
    SaveOrganizationDataById: ({ id }: { id: any }) =>
        apiClient
            .post(URLS.getOrganizationsById, {
                data: {
                    id,
                },
            })
            .then((res) => {
                return res; // Return the response if needed
            }),
};

export default OrganizationsByIdApi;
